
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/accounting/accounts"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('coa') }}</router-link> 
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="save">
                <i class="fa fa-floppy-o"></i> {{ $t('save') }}
            </button>
        </div>
        <div class="x_body">
            <div class="card f_card">
            <div class="card-body">
                <div v-if="$v.$error" class="alert alert-danger x-error">
                    <div class="error" v-if="!$v.model.Num.required">- Please enter account number.</div>
                    <div class="error" v-if="!$v.model.AccountTypeId.required">- Please select account type.</div>
                    <div class="error" v-if="!$v.model.Name.required">- Please enter account name.</div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.AccountTypeId.$error }">
                                    <label class="label-control blue">{{ $t('account_type') }}</label>
                                    <div>
                                        <select class="form-control form-control-sm" v-model="$v.model.AccountTypeId.$model" @change="typeChange">
                                            <option v-for="(ret,index) in types" :value="ret.Id" :key="index">{{ret.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.Num.$error }">
                                    <label class="label-control blue">{{ $t('account_no') }} </label>
                                    <div>
                                        <input class="form-control form-control-sm" type="text" v-model="$v.model.Num.$model"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group"  :class="{ 'form-group-error': $v.model.Name.$error }">
                            <label class="label-control blue">{{ $t('account_name') }}</label>
                            <div><input class="form-control form-control-sm" type="text" v-model="$v.model.Name.$model"/></div>
                        </div>
                        <div class="form-group">
                            <label class="blue">{{ $t('description') }} </label>
                            <div>
                                <textarea class="form-control" v-model="model.Description"></textarea>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="blue">{{ $t('sort') }} </label>
                            <div>
                                <input type="number" class="form-control" v-model="model.Sort"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>          
        </div>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
export default {
    data: function(){
        return {
            model: {
                Num: '',
                AccountTypeId: '',
                AccountTypeName: '',
                Name: '',
                Sort: 1
            },
            types: [],
            actionLink: 'accounting/account/save',
            title: this.$t('add_new')
        }
    },
    created(){
        this.accountTypeList();
        var id = this.$route.params.id;
        if(id != undefined){
            this.findById(id);
        }
    },
    validations: {
        model :{
            AccountTypeId: { required },
            Num: { required },
            Name: { required }
        }
    },
    methods: {
        findById: function(id){
            var loading = this.$loading.show();
            this.$api().post('accounting/account/find', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    this.model = res.data.Data;
                    this.title = '['+ this.model.Name + ']';
                }
            }).finally(function(){ loading.hide(); });
        },
        save: function(){
            this.$v.$touch();
            if(!this.$v.$invalid) {
                var loading = this.$loading.show();
                this.$api().post(this.actionLink, this.model).then(res => {
                    if (this.$isValid(res)) {
                        this.$router.go(-1);
                    }
                }).finally(function () {
                    loading.hide();
                });
            }
        },
        accountTypeList: async function(){
            var res = await this.$api().post('accounting/types', {});
            if(this.$isValid(res)){
                this.types = res.data.Data;
            }
        },
        typeChange(){
            for(var i = 0; i < this.types.length; i++){
                let item = this.types[i];
                if(item.Id == this.model.AccountTypeId){
                    this.model.AccountTypeName = item.Name;
                    break;
                }
            }
        }
    }
}
</script>
